module.exports = __webpack_public_path__ + "static/media/kawaki.9329721c.jpg";